import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationMenu from './NotificationMenu';
import AvatarCircle from './AvatarCircle';
import { useAuth } from '../context/AuthContext';

const Header = ({ api, unreadCount }) => {

  const navigate = useNavigate()
  const { user, token } = useAuth()

  return (
    <header className="fixed top-0 left-0 w-full bg-gray-800 text-white shadow-md z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center p-4">
        <h1 className="text-xl font-bold"><a href={token ? "/home" : "/"}>wwyb</a></h1>
        <nav>
          <ul className="flex items-center space-x-4">
            {token ? <li><a href="/home" className="hover:text-gray-400">Home</a></li> : <div />}
            {token ? <li><a href="/users/search" className="hover:text-gray-400">Find friends</a></li> : <div />}
            {token ? <div onClick={() => navigate("/me")}><AvatarCircle letters={user && user.firstName ? `${user.firstName} ${user.lastName}` : ""} size={"size-8"} textSize={"text-sm"} /></div> : <a href="/login" className="hover:text-gray-400">Log in</a>}
            {token ? <NotificationMenu api={api} unreadCount={unreadCount} /> : <div />}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
